import axiosBase, {
  AxiosRequestConfig,
  AxiosInterceptorManager,
  AxiosResponse,
  AxiosInstance,
} from 'axios';
import { config } from 'src/constants/app';

export default class Axios {
  public instance: AxiosInstance;

  public interceptors: {
    request: AxiosInterceptorManager<AxiosRequestConfig>;
    response: AxiosInterceptorManager<AxiosResponse>;
  };

  public constructor(configOptional?: AxiosRequestConfig) {
    this.instance = axiosBase.create(configOptional || config);
    this.interceptors = this.instance.interceptors;
  }
}
